/** This export is automatically generated */
export const gitHash = 'af3d3032';
